import { render } from "lit-html";
import { CheckableFormField } from "Components/abstract/sde-e-checkable-form-field/sde-e-checkable-form-field";

export class CheckBox extends CheckableFormField {
  protected get DEFAULT_ERROR_MESSAGE(): string {
    return "Please accept this Field.";
  }

  public get submitString(): string | undefined {
    if (this.isChecked === false) return undefined;

    if (this.label !== "") return this.label;
    return this.name;
  }

  protected async renderAsync() {
    const { checkBoxTemplate } = await import("./sde-e-check-box.template");
    render(
      checkBoxTemplate({
        id: this.uuid,
        name: this.name,
        label: this.label,
        labelMarkup: this.labelMarkup,
        isRequired: this.isRequired,
        isDisabled: this.isDisabled,
        isReadonly: this.isReadonly,
        description: this.description,
        showError: this.state.showError,
        isChecked: this.isChecked,
        handleCheckedChange: () => this.handleCheckedChange(),
        errorMessage: this.errorMessage,
      }),
      this.getUiRoot(),
    );
  }

  protected async handleFocusOut() {
    await super.handleFocusOut();
    const currentValue = this.submitValue || "";
    const isValid = await this.isValid();
    if (currentValue === "" && isValid) return;
    await this.validate();
    await this.reRenderHook();
  }
}

customElements.define("sde-e-check-box", CheckBox);
